import React from 'react';
import { Loader } from '@exxonmobil/react-unity';
import ReactEcharts from 'echarts-for-react';
import styled from 'styled-components';
import { VolumeValidation } from '../../common/types/TrendsTypes';
import { ErrorBox } from '../../common/components/ErrorBox';

interface Props {
  data: VolumeValidation;
  isLoading: boolean;
  error: string;
  onRefresh: () => void;
}

// const getTotalUsage = (apiUsage: number[], eventUsage: number[]) => {
//   const totalUsage = [];
//   // Extra check for trends.test.tsx
//   if (!Array.isArray(apiUsage) || !Array.isArray(eventUsage)) {
//     return [];
//   }
//   for (let i = 0; i < apiUsage.length; i += 1) {
//     totalUsage.push(apiUsage[i] + eventUsage[i]);
//   }
//   return totalUsage;
// };

const DomainChart = ({ data, isLoading, error, onRefresh }: Props) => {
  // const totalUsage = getTotalUsage(data.apiUsage, data.eventUsage);

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    legend: {
      data: ['Event Usage', 'API Usage', 'Total Usage']
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: false,
        data: data.dates
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [
      {
        name: 'Event Usage',
        type: 'line',
        stack: 'Total',
        areaStyle: {},
        smooth: true,
        emphasis: {
          focus: 'series'
        },
        data: data.eventUsage
      },
      {
        name: 'API Usage',
        type: 'line',
        stack: 'Total',
        areaStyle: {},
        smooth: true,
        emphasis: {
          focus: 'series'
        },
        data: data.apiUsage
      }
      // {
      //   name: 'Total Usage',
      //   type: 'line',
      //   stack: 'Total',
      //   areaStyle: {},
      //   emphasis: {
      //     focus: 'series'
      //   },
      //   data: totalUsage
      // }
    ]
  };
  if (error) {
    if (error === '401' || error === '403') {
      return <EmptyDataContainer>Sessions timeout, please close the page and login again.</EmptyDataContainer>;
    }
    return <ErrorBox onRefresh={onRefresh} isRefreshable />;
  }
  if (isLoading) {
    return (
      <EmptyDataContainer style={{ paddingBottom: '2rem' }}>
        <Loader data-testid="domain-volume-chart-loading" className="em-u-margin loader" />
      </EmptyDataContainer>
    );
  }
  if (!data.dates || data.dates.length === 0) {
    return <EmptyDataContainer>No data available</EmptyDataContainer>;
  }
  return (
    <ReactEcharts opts={{ renderer: 'svg', width: 'auto', height: 300 }} option={option} style={{ height: '300px' }} />
  );
};

const EmptyDataContainer = styled.div`
  text-align: center;
  padding-top: 2rem;
  min-height: 5rem;
`;

export default DomainChart;
